import { itemsOnPage } from "../assets/const";
import { api } from "../App";
import {
  SET_CANDIDATES_ADDITIONAL_EDUCATION, SET_CANDIDATES_ADDRESS, SET_CANDIDATES_BENEFITS,
  SET_CANDIDATES_BENEFITS_REFERENCE, SET_CANDIDATES_DATA, SET_CANDIDATES_DOCUMENTS,
  SET_CANDIDATES_ENTRANCE, SET_CANDIDATES_EXAM_CITY, SET_CANDIDATES_FORM,
  SET_CANDIDATES_INFO, SET_CANDIDATES_LANGUAGES, SET_CANDIDATES_LIST,
  SET_CANDIDATES_LOADING, SET_CANDIDATES_MEDICINE_INFO, SET_CANDIDATES_PARENTS,
  SET_CANDIDATES_NOTIFICATIONS, SET_CANDIDATES_SCHEDULE_TEST
} from "./types";
import { createNotification } from "../components/Notifications/Notifications";


export const setPage = (pageNumber) => ({ type: SET_CANDIDATES_FORM, payload: { pageNumber } })

export const getCandidatesList = (filters = {}) => async (dispatch, getState) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    const { pageNumber } = getState().candidates.form
    const limit = itemsOnPage
    const offset = itemsOnPage * pageNumber

    const params = { limit, offset }

    if (filters.school_year_id) params.school_year_id = filters.school_year_id
    if (filters.date_from) params.date_from = filters.date_from
    if (filters.date_to) params.date_to = filters.date_to
    if (filters.status_id) params.status_id = filters.status_id
    if (filters.war_arms) params.war_arms = filters.war_arms
    if (filters.war_districts) params.war_districts = filters.war_districts

    const urlParams = new URLSearchParams(params).toString();
    const { data: responseData } = await api.get(`/applicant?${urlParams}`);
    const list = responseData.data
    const total = responseData.total_count
    const pageCount = Math.ceil(total / itemsOnPage)

    dispatch({ type: SET_CANDIDATES_LIST, payload: list });
    dispatch({ type: SET_CANDIDATES_FORM, payload: { pageCount, count: total } });
  } catch (error) {
    console.error('Error loading candidates list:', error);
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

export const getCandidateData = (id) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    const { data: payload } = await api.get(`/applicant/${id}/main`);
    dispatch({ type: SET_CANDIDATES_DATA, payload });
  } catch (error) {
    console.error('Error loading candidate data:', error);
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

export const getCandidateAddresses = (id) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    const { data: payload } = await api.get(`/applicant/${id}/address`);
    dispatch({ type: SET_CANDIDATES_ADDRESS, payload });
  } catch (error) {
    console.error('Error loading candidate addresses:', error);
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

export const getCandidateBenefits = (id) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    const { data: payload } = await api.get(`/applicant/${id}/benefits`);
    dispatch({ type: SET_CANDIDATES_BENEFITS, payload });
  } catch (error) {
    console.error('Error loading candidate benefits:', error);
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

export const getBenefitsReference = () => async (dispatch, getState) => {
  const { benefits_reference } = getState().candidates.data
  if (benefits_reference) return
  try {
    const { data: payload } = await api.get('/applicant/benefits-reference');
    dispatch({ type: SET_CANDIDATES_BENEFITS_REFERENCE, payload });
  } catch (error) {
    console.error('Error loading benefits reference:', error);
  }
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const addCandidateBenefit = (id, benefitData) => async (dispatch) => {
  try {
    await api.post(`/applicant/${id}/benefits`, benefitData);
    dispatch(getCandidateBenefits(id));
    createNotification('success', 'Льгота добавлена');
  } catch (error) {
    console.error('Error adding benefit:', error);
    createNotification('error', 'Ошибка добавления льготы');
  }
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const deleteCandidateBenefit = (id, code) => async (dispatch) => {
  try {
    await api.delete(`/applicant/${id}/benefits/${code}`);
    dispatch(getCandidateBenefits(id));
    createNotification('success', 'Льгота удалена');
  } catch (error) {
    console.error('Error deleting benefit:', error);
    createNotification('error', 'Ошибка удаления льготы');
  }
};

// Не задокументирован в Postman-коллекции — эндпойнт может отсутствовать на бэкенде
export const editCandidateBenefit = (id, code, benefitData) => async (dispatch) => {
  try {
    await api.put(`/applicant/${id}/benefits/${code}`, benefitData);
    dispatch(getCandidateBenefits(id));
    createNotification('success', 'Льгота обновлена');
  } catch (error) {
    console.error('Error editing benefit:', error);
    createNotification('error', 'Ошибка обновления льготы');
  }
};

export const getCandidateEntrance = (id) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    const { data: payload } = await api.get(`/applicant/${id}/entrance`);
    dispatch({ type: SET_CANDIDATES_ENTRANCE, payload });
  } catch (error) {
    console.error('Error loading candidate entrance:', error);
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

export const getCandidateMedicineInfo = (id) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    const { data: payload } = await api.get(`/applicant/${id}/medicine_info`);
    dispatch({ type: SET_CANDIDATES_MEDICINE_INFO, payload });
  } catch (error) {
    console.error('Error loading candidate medicine info:', error);
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

export const getCandidateAdditionalEducation = (id) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    const { data: payload } = await api.get(`/applicant/${id}/additional_education`);
    dispatch({ type: SET_CANDIDATES_ADDITIONAL_EDUCATION, payload });
  } catch (error) {
    console.error('Error loading candidate additional education:', error);
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

export const getCandidateDocuments = (id) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    const { data: payload } = await api.get(`/applicant/${id}/documents`);
    dispatch({ type: SET_CANDIDATES_DOCUMENTS, payload });
  } catch (error) {
    console.error('Error loading candidate documents:', error);
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const addCandidateDocument = (id, docData) => async (dispatch) => {
  try {
    await api.post(`/applicant/${id}/documents`, docData);
    dispatch(getCandidateDocuments(id));
    createNotification('success', 'Документ добавлен');
  } catch (error) {
    console.error('Error adding document:', error);
    createNotification('error', 'Ошибка добавления документа');
  }
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const updateCandidateDocument = (id, docId, docData) => async (dispatch) => {
  try {
    await api.put(`/applicant/${id}/documents/${docId}`, docData);
    dispatch(getCandidateDocuments(id));
    createNotification('success', 'Документ обновлён');
  } catch (error) {
    console.error('Error updating document:', error);
    createNotification('error', 'Ошибка обновления документа');
  }
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const deleteCandidateDocument = (id, docId) => async (dispatch) => {
  try {
    await api.delete(`/applicant/${id}/documents/${docId}`);
    dispatch(getCandidateDocuments(id));
    createNotification('success', 'Документ удалён');
  } catch (error) {
    console.error('Error deleting document:', error);
    createNotification('error', 'Ошибка удаления документа');
  }
};

export const getCandidateInfo = (id) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    const { data: payload } = await api.get(`/applicant/${id}/info`);
    dispatch({ type: SET_CANDIDATES_INFO, payload });
  } catch (error) {
    console.error('Error loading candidate info:', error);
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

export const getCandidateParents = (id) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    const { data: payload } = await api.get(`/applicant/${id}/parents`);
    dispatch({ type: SET_CANDIDATES_PARENTS, payload });
  } catch (error) {
    console.error('Error loading candidate parents:', error);
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

export const getCandidateExamCity = () => async (dispatch) => {
  try {
    const { data: payload } = await api.get(`/applicant/main/exam_city`);
    dispatch({ type: SET_CANDIDATES_EXAM_CITY, payload });
  } catch (error) {
    console.error('Error loading exam city:', error);
  }
};

export const getCandidateLanguages = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/applicant/main/second_languages`);
    const payload = data.courses
    dispatch({ type: SET_CANDIDATES_LANGUAGES, payload });
  } catch (error) {
    console.error('Error loading languages:', error);
  }
};

export const getCandidateNotifications = () => async (dispatch) => {
  try {
    const { data } = await api.get(`/applicant/notifications/templates`);
    const payload = data.data
    dispatch({ type: SET_CANDIDATES_NOTIFICATIONS, payload });
  } catch (error) {
    console.error('Error loading notifications:', error);
  }
};

export const sendCandidateNotification = (data, applicantNames = []) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    await api.post(`/applicant/notifications/send`, data);
    createNotification('success', 'Извещения отправлены');
  } catch (error) {
    console.error('Error sending candidate notification:', error);
    const errorData = error.response?.data;
    const names = applicantNames.join(', ');
    const isEmailMode = data.send_mode === 0;

    if (typeof errorData === 'string' && errorData.includes('E-Mail')) {
      createNotification('error', isEmailMode ? errorData : 'Ошибка при отправке извещения');
    } else if (errorData?.message?.includes('E-Mail') || errorData?.detail?.includes('E-Mail')) {
      createNotification('error', isEmailMode ? (errorData.message || errorData.detail) : 'Ошибка при отправке извещения');
    } else if (error.response?.status === 400 || error.response?.status === 422) {
      createNotification('error', isEmailMode
        ? `У следующих претендентов не задан E-Mail для переписки: ${names}`
        : 'Ошибка при отправке извещения');
    } else {
      createNotification('error', 'Ошибка отправки извещения');
    }
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
}

// ==================== SAVE ACTIONS (PUT) ====================

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const saveCandidateData = (id, data) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    await api.put(`/applicant/${id}/main`, data);
    dispatch({ type: SET_CANDIDATES_DATA, payload: data });
    createNotification('success', 'Данные успешно сохранены');
  } catch (error) {
    console.error('Error saving candidate data:', error);
    createNotification('error', 'Ошибка сохранения данных');
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const saveCandidateAddresses = (id, data) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    await api.put(`/applicant/${id}/address`, data);
    dispatch({ type: SET_CANDIDATES_ADDRESS, payload: data });
    createNotification('success', 'Адреса успешно сохранены');
  } catch (error) {
    console.error('Error saving candidate addresses:', error);
    createNotification('error', 'Ошибка сохранения адресов');
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const saveCandidateEntrance = (id, data) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    await api.put(`/applicant/${id}/entrance`, data);
    dispatch({ type: SET_CANDIDATES_ENTRANCE, payload: data });
    createNotification('success', 'Данные поступления успешно сохранены');
  } catch (error) {
    console.error('Error saving candidate entrance:', error);
    createNotification('error', 'Ошибка сохранения данных поступления');
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const saveCandidateMedicineInfo = (id, data) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    await api.put(`/applicant/${id}/medicine_info`, data);
    dispatch({ type: SET_CANDIDATES_MEDICINE_INFO, payload: data });
    createNotification('success', 'Медицинская информация успешно сохранена');
  } catch (error) {
    console.error('Error saving candidate medicine info:', error);
    createNotification('error', 'Ошибка сохранения медицинской информации');
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const saveCandidateAdditionalEducation = (id, data) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    await api.put(`/applicant/${id}/additional_education`, data);
    dispatch({ type: SET_CANDIDATES_ADDITIONAL_EDUCATION, payload: data });
    createNotification('success', 'Дополнительное образование успешно сохранено');
  } catch (error) {
    console.error('Error saving candidate additional education:', error);
    createNotification('error', 'Ошибка сохранения дополнительного образования');
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const saveCandidateInfo = (id, data) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    await api.put(`/applicant/${id}/info`, data);
    dispatch({ type: SET_CANDIDATES_INFO, payload: data });
    createNotification('success', 'Информация о кандидате успешно сохранена');
  } catch (error) {
    console.error('Error saving candidate info:', error);
    createNotification('error', 'Ошибка сохранения информации о кандидате');
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const saveCandidateParents = (id, data) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    await api.put(`/applicant/${id}/parents`, data);
    dispatch({ type: SET_CANDIDATES_PARENTS, payload: data });
    createNotification('success', 'Данные родителей успешно сохранены');
  } catch (error) {
    console.error('Error saving candidate parents:', error);
    createNotification('error', 'Ошибка сохранения данных родителей');
  }
  dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
};

// ==================== CRUD ACTIONS ====================

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — в коллекции есть только публичная
// POST /applicant/registration, это другой эндпойнт; данный POST /applicant может отсутствовать на бэкенде
export const createCandidate = (data) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    const response = await api.post(`/applicant`, data);
    createNotification('success', 'Претендент успешно создан');
    return response.data;
  } catch (error) {
    console.error('Error creating candidate:', error);
    createNotification('error', 'Ошибка создания претендента');
    return null;
  } finally {
    dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
  }
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const deleteCandidate = (id) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    await api.delete(`/applicant/${id}`);
    createNotification('success', 'Претендент успешно удалён');
    return true;
  } catch (error) {
    console.error('Error deleting candidate:', error);
    createNotification('error', 'Ошибка удаления претендента');
    return false;
  } finally {
    dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
  }
};

export const updateCandidateStatus = (applicantId, newStatusId, extra = {}) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    await api.post(`/applicant/change-status`, {
      applicant_id: applicantId,
      new_status_id: newStatusId,
      ...extra, // gid, order_date, order_number, order_mo, mo_date, data_prikaza
    });
    createNotification('success', 'Статус претендента изменён');
    return true;
  } catch (error) {
    console.error('Error updating candidate status:', error);
    createNotification('error', 'Ошибка изменения статуса');
    return false;
  } finally {
    dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
  }
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const addCandidateScheduleTest = (id, scheduleData) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    const { data } = await api.post(`/applicant/${id}/schedule_test`, scheduleData);
    dispatch({ type: SET_CANDIDATES_SCHEDULE_TEST, payload: data });
    createNotification('success', 'Запись добавлена');
    return true;
  } catch (error) {
    console.error('Error adding schedule test:', error);
    createNotification('error', 'Ошибка добавления записи');
    return false;
  } finally {
    dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
  }
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const copyCandidate = (id) => async (dispatch) => {
  dispatch({ type: SET_CANDIDATES_LOADING, payload: true });
  try {
    const { data } = await api.post(`/applicant/${id}/copy`);
    createNotification('success', 'Претендент скопирован');
    return data;
  } catch (error) {
    console.error('Error copying candidate:', error);
    createNotification('error', 'Ошибка копирования');
    return null;
  } finally {
    dispatch({ type: SET_CANDIDATES_LOADING, payload: false });
  }
};

export const exportCandidatesExcel = (filters = {}) => async () => {
  try {
    const params = {}
    if (filters.school_year_id) params.school_year_id = filters.school_year_id
    if (filters.date_from) params.date_from = filters.date_from
    if (filters.date_to) params.date_to = filters.date_to
    if (filters.status_id) params.status_id = filters.status_id
    if (filters.war_arms) params.war_arms = filters.war_arms
    if (filters.war_districts) params.war_districts = filters.war_districts
    const urlParams = new URLSearchParams(params).toString()
    const response = await api.get(`/applicant/export/excel?${urlParams}`, { responseType: 'blob' })
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'candidates.xlsx')
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Error exporting to Excel:', error);
    createNotification('error', 'Ошибка экспорта в Excel');
  }
};

// Не задокументирован в Postman-коллекции (Export 2026-06-29) — эндпойнт может отсутствовать на бэкенде
export const printAdmissionCertificate = (applicantId) => async () => {
  try {
    const response = await api.get(`/applicant/${applicantId}/admission_certificate`, { responseType: 'blob' })
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
    window.open(url, '_blank')
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Error printing admission certificate:', error)
    createNotification('error', 'Ошибка печати справки-подтверждения поступления')
  }
}

// Не задокументирован в Postman-коллекции — эндпойнт может отсутствовать на бэкенде
export const printExamTickets = (applicantIds = []) => async () => {
  try {
    const query = applicantIds.map(id => `applicant_id=${id}`).join('&')
    const response = await api.get(`/applicant/print/exam_tickets?${query}`, { responseType: 'blob' })
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
    window.open(url, '_blank')
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Error printing exam tickets:', error)
    createNotification('error', 'Ошибка печати экзаменационных билетов')
  }
}

// Не задокументирован в Postman-коллекции — эндпойнт может отсутствовать на бэкенде
export const printInterviewSheet = (applicantIds = []) => async () => {
  try {
    const query = applicantIds.map(id => `applicant_id=${id}`).join('&')
    const response = await api.get(`/applicant/print/interview_sheet?${query}`, { responseType: 'blob' })
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
    window.open(url, '_blank')
    window.URL.revokeObjectURL(url)
  } catch (error) {
    console.error('Error printing interview sheet:', error)
    createNotification('error', 'Ошибка печати листа собеседования')
  }
}

// sendNotice is kept for backward compatibility (uses POST /applicant_letters directly)
export const sendNotice = (data) => async () => {
  try {
    await api.post(`/applicant_letters`, data);
  } catch (error) {
    console.error('Error sending notice:', error);
  }
}
